<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">{{ $t("auto.teamChatFeature") }}</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.maxSessionCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.maxSessionCount" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.maxSessionCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.maxSessionCount" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.otherFeatures") }}</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.chatbotButtonActivity">{{ $t("auto.chatbotButtonActivity") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.chatbotButtonActivity">{{ $t("auto.chatbotButtonActivity") }}</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems } from "./index";

export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            private: false,
            maxTeamChatArchiveTime: 0,
            teamChatArchiveTime: 0,
            team: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.TEAM_CHAT);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler() {},
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
